export interface IOpportunityDetail {
  code: string;
  content: string;
}

export class OpportunityDetail {
  public code: string;
  public content: string;

  constructor(data: IOpportunityDetail) {
    this.code = data.code;
    this.content = data.content;
  }
}
